<div class="shareSettingsForPass">
  <!-- <div *ngIf ="loading" class="loading-indicator">
    <mat-spinner diameter="45" strokeWidth='7'></mat-spinner>
  </div> -->
  <div *ngIf="!loading">
    <h2 id="dialog_title" mat-dialog-title style="font-size:17px;  margin-bottom: 10px;">Share settings</h2>

    <div id="container" style="padding-bottom: 10px; ">
      <div id="left" class="iconConatainer float-left">
        <!-- <ng-template [ngIf]="types == 'folder'">
          <img src="./assets/folder.png" width="23">
        </ng-template> -->
        <ng-template [ngIf]="types == 'file'">
          <img src="./assets/{{getFileIcon()}}_icon.svg" width="23" />
        </ng-template>

        <ng-template [ngIf]="types  == 'folder'&& foldertype && foldertype=='SMART'">
          <img src="./assets/smart_folder_icon_new.svg" width="23">
        </ng-template>
        <ng-template [ngIf]="types  == 'folder'&& foldertype && foldertype!='SMART'">
          <img src="./assets/folder.svg" width="23">
        </ng-template>      
      </div>
      <div id="right" class="overflowHidden">
        <div id="nameDialog" class="mat-line mat-tooltip-trigger">{{name}}</div>
        <ng-template [ngIf]="type">
          <div class="sharelinksize">
            {{size| filesize }} {{', '+lastmodified}}
          </div>
        </ng-template>
        <ng-template [ngIf]="!type">
          <div class="sharelinksize">
            {{lastmodified}}
          </div>
        </ng-template>
      </div>
    </div>
    <h3 *ngIf="isrestrictionchanged" class="sharereschange">{{shareRestricted}}</h3>
    <section>
      <form *ngIf="accessible" [formGroup]="accessibleByFg" class="msTeam-settings">
        <mat-form-field class="full-width-field">
          <mat-label class="secondary-color" id="accessibleByDialog">Accessible by</mat-label>
          <mat-select placeholder="Accessible by" formControlName="accessibleByFc"
            (selectionChange)="onAccessibleChange($event)">
            <mat-option *ngFor="let access of accessible" [value]="access" class="share-option">
              {{access.displayname}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </section>
    <!-- <form *ngIf="accessibleindex==3" [formGroup]="passwordFg">
      <mat-form-field>
        <mat-label>Share link password</mat-label>
        <input matInput [readonly]="true" placeholder="Min 5 characters" formControlName="passwordFc"
          [(ngModel)]="password">
      </mat-form-field>
    </form> -->
    <mat-form-field *ngIf="accessibleindex==3" class="full-width-field anyone-sharepassword">
      <mat-label class="secondary-color">Share link password</mat-label>
      <input matInput [formControl]="passwordFc" [(ngModel)]="password" required [type]="hide ? 'password' : 'text'">
      <!-- <img src="./assets/{{getPasswordIcon()}}_password_icon.svg" width="24" height="24" alt="file" class="float-right" (click)="hide = !hide"> -->
      <div *ngIf="hide" class="eyehideIcon" alt="eyehideIcon"  (click)="hide = !hide"></div>
      <div *ngIf="!hide" class="eyeshowIcon" alt="eyeshowIcon"  (click)="hide = !hide"></div>

      <mat-placeholder class="placeholder">Min 8 characters</mat-placeholder>
      <mat-error *ngIf="passwordFc.invalid">{{getErrorMessage(passwordFc)}}</mat-error>
    </mat-form-field>

    <app-passoword-strength-bar *ngIf="accessibleindex==3" [passwordToCheck]="password" [barLabel]="barLabel">  </app-passoword-strength-bar> 
    <section>
      <form *ngIf="downloadrights && isfile" [formGroup]="downloadRightsFg" class="msTeam-settings">
        <mat-form-field class="full-width-field">
          <mat-label class="secondary-color" id="downloadRights">Download rights</mat-label>
          <mat-select placeholder="Download rights" formControlName="downloadRightsFc"
            (selectionChange)="onDownloadChange($event)">
            <mat-option *ngFor="let download of downloadrights" [value]="download" class="share-option">
              {{download.displayname}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </section>

    <section *ngIf="downloadindex==1 && isfile">
      <!-- <mat-slide-toggle class="msTeam-settings" style="padding-bottom: 10px; margin-top: -5px;" color="primary" [checked]="isWaterMark"
                        (change)="onToggleWaterMark($event)">
        Apply watermark
      </mat-slide-toggle> -->
      <div class="toggleContainer" style="margin-bottom:10px;">
        <div class="q">Apply watermark</div>
        <input aria-label="Apply watermark" type="checkbox" [checked]="isWaterMark" name="isWaterMark" id="isWaterMark" [(ngModel)]="isWaterMark">
        <label for="isWaterMark" data-on="Yes" data-off="No" class="primary-color"></label>
      </div>
    </section>

    <section *ngIf="downloadindex==2 && isfile">
      <!-- <mat-slide-toggle class="msTeam-settings" style="padding-bottom: 10px; margin-top: -5px;" color="primary" [checked]="isApproveVersions"
                        (change)="onToggleApproveVersion($event)">
        Approve new versions
      </mat-slide-toggle> -->
      <div class="toggleContainer" style="margin-bottom:10px;">
        <div class="q">Approve new versions</div>
        <input aria-label="Approve new versions" type="checkbox" [checked]="isApproveVersions" name="isApproveVersions" id="isApproveVersions" [(ngModel)]="isApproveVersions">
        <label for="isApproveVersions" data-on="Yes" data-off="No" class="primary-color"></label>
      </div>
    </section>

    <section>
      <form *ngIf="linkexpires" [formGroup]="linkExpiresFg" class="msTeam-settings">
        <mat-form-field class="full-width-field">
          <mat-label class="secondary-color" id="linkExpireDialog">Link expires</mat-label>
          <mat-select placeholder="Link expires" formControlName="linkExpiresFc"
            (selectionChange)="onLinkChange($event)">
            <mat-option *ngFor="let linkexpire of linkexpires;let i = index;" [value]="linkexpire" class="share-option">
              <span *ngIf="i==0">{{linkexpire.displayname}}</span>
              <span *ngIf="i!=0">After {{linkexpire.displayname}} days</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>

    </section>

    <section>
      <!-- <mat-slide-toggle id="notifymeDialog" class="msTeam-settings" color="primary" style="padding-bottom: 10px; margin-top: -5px;" [checked]="notifyEditdownload"
                        (change)="onToggleNotify($event)">
        Notify me by email when recipients edit, download, view or print
      </mat-slide-toggle> -->
      <div class="toggleContainer">
        <div class="q">Notify me by email when recipients edit, download, view or print</div>
        <input aria-label="Notify me by email when recipients edit, download, view or print" type="checkbox" [checked]="notifyEditdownload" name="notifyEditdownload" id="notifyEditdownload" [(ngModel)]="notifyEditdownload">
        <label for="notifyEditdownload" data-on="Yes" data-off="No" class="primary-color"></label>
      </div>

    </section>
  </div>
  

  <div class="global-footer add-divider" style=" position: absolute; bottom: 0; left: 0; right: 0;">
    <div style="padding-top: 12px;"></div>
    <div class="error-msg" [innerHTML]="errorMsg.str" *ngIf="errorMsg.str.length >0 && !loading" ></div>

    <!-- <div class="msTeam-modal-footerdialog" *ngIf="dialogRef != null">
      <button id="cancel_btn" mat-raised-button (click)="closeDialog()">Cancel</button>
      <button id="share_btn" class="msTeam-btn" mat-raised-button style="margin-left:10px;"
        [disabled]="passwordFc.invalid && accessibleindex==3" (click)="shareItem()">{{sharetitle}}</button>
    </div> -->

    <div class="msTeam-modal-footerdialog"
      style=" margin-right: 12px; padding-top: 10px;"
      *ngIf="dialogRef == null">
      <button mat-raised-button (click)="closeDialog()" class="cancelBtn">Cancel</button>
      <button id="share_btn" class="msTeam-btn" mat-raised-button style="margin-left:10px;"
        [disabled]="(passwordFc.invalid && accessibleindex==3)||sharebutton.isDisabled" (click)="shareItem()" *ngIf="errorMsg.str.length ==0">{{sharebutton.sharetitle}}</button>
        <button id="share_btn" class="msTeam-btn" mat-raised-button style="margin-left:10px;"
        [disabled]="(passwordFc.invalid && accessibleindex==3)||sharebutton.isDisabled" (click)="shareItem()" *ngIf="errorMsg.str.length > 0">{{sharebutton.sharetitledefault}}</button>
    </div>
  </div>
</div>
